import httpClient from './httpClient'

const suggestionDescriptionSheets = {
    getList(desSheetId) {
        return httpClient.get(`/api/business-support/suggestion/description-sheets/${desSheetId}`).then(
            response => response.success ? response.suggestDescriptionSheets : undefined
        )
    }
}

export default suggestionDescriptionSheets